import timon from "../images/icons/timon-blanco.svg";
import { useState } from "react";
import { ProfilePage1 } from "../components/profile/ProfilePage1";
import { ProfilePage2 } from "../components/profile/ProfilePage2";
import { ProfilePage3 } from "../components/profile/ProfilePage3";
import { ProfilePage4 } from "../components/profile/ProfilePage4";
import { ProfilePage5 } from "../components/profile/ProfilePage5";
import { ProfilePage6 } from "../components/profile/ProfilePage6";
import { useCookies } from "react-cookie";

export function Profile({ user, setUser, changeSection }) {

  const [page, setPage] = useState(1);

  const [cookies, setCookie, removeCookie] = useCookies(["session"]);

  function closeSession() {
    setUser(null);
    changeSection("search");
    console.log("cerrando sesion");
    removeCookie("session");
  }

  return (
    <>
      <div className="total content-section a-bg a-bg--fixed bgRegister" >
        <div className="container">
          <div className="m-layMiCuenta">
            {/* <!-- aside --> */}
            <aside>
              <div className="bx">
                <br/>
                <div className="m-iconTit">
                  <img src={timon} alt="flotador-naranja" className="icon"/>
                  <span className="tit">Mi cuenta</span>
                </div>
                <br/>
                <div className="m-mainUser">
                  <ul>
                    <li className={page ==1 ? "current": ""}>
                      <div  onClick={() => {
                        setPage(1)
                      }}>
                        <span >Mi perfil</span>
                        <span>Edita tus datos personales</span>
                      </div>
                    </li>
                    <li className={page ==2 ? "current": ""}>
                      <div onClick={() => {
                        setPage(2)
                      }}>
                        <span>Ajustes de cuenta</span>
                        <span>Edita tus ajustes</span>
                      </div>
                    </li>
                    <li className="">
                    <div onClick={() => {
                        setPage(3)
                      }}>
                        <span>Mis bonificaciones</span>
                        <span>Edita o añade bonificaciones</span>
                      </div>
                    </li>
                    <li className="">
                    <div onClick={() => {
                        setPage(4)
                      }}>
                        <span>Mis compras</span>
                        <span>Revisa tus compras</span>
                      </div>
                    </li>
                    <li className="">
                    <div onClick={() => {
                        setPage(5)
                      }}>
                        <span>Mis preferencias</span>
                        <span>Edita tus preferencias</span>
                      </div>
                    </li>
                    <li className="">
                    <div onClick={() => {
                        setPage(6)
                      }}>
                        <span>Pasajeros</span>
                        <span>Añade o edita pasajeros</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <br/>
                <div className="btnWhite-m" onClick={closeSession}>Cerrar sesión</div>
              </div>
            </aside>
            {page === 1 && (<ProfilePage1 user={user}/>)}
            {page === 2 && (<ProfilePage2 user={user}/>)}
            {page === 3 && (<ProfilePage3 user={user}/>)}
            {page === 4 && (<ProfilePage4 user={user}/>)}
            {page === 5 && (<ProfilePage5 user={user}/>)}
            {page === 6 && (<ProfilePage6 user={user}/>)}
          </div>
        </div>
      </div>
    </>
  );
}